export const PERMISSIONS = {
	canCreateUser: 'canAddUsers',
	canCreateUserGroup: 'canCreateUserGroup',
	canViewUser: 'canViewUserDetails',
	canDeleteUser: 'canDeleteUser',
	canDisableUser: 'canDisableUser',
	canChangeGroupMemberships: 'canChangeGroupMemberships',
	canResetPasswords: 'canResetPasswords',
	canChangeUserDetails: 'canChangeUserDetails',
	canChangeOwnDetails: 'canChangeOwnDetails',
	canViewOwnDetails: 'canViewOwnDetails',
	canGetData: 'canGetData',
	canListGames: 'canListGames',
	canListCampaigns: 'canListCampaigns',
	canGetSkinPrefs: 'canGetSkinPrefs',
	canSetSkinPrefs: 'canSetSkinPrefs',
};
